<div class="drinking" [style.background-image]="statesService.backgroundImageSrc + statesService.imageNumber + '.webp)'"></div>
